import { render, staticRenderFns } from "./ScopeModal.vue?vue&type=template&id=54f6c548"
import script from "./ScopeModal.vue?vue&type=script&lang=js"
export * from "./ScopeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports